import React from 'react'
import { IconProps, IconWrapper } from './IconWrapper'
const renderIcon = (color: string) => (
    <path
        d='M15 4L8 12L15 20'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill='none'
        fillRule='evenodd'
    />
)
export const ChevronLeft: React.FC<IconProps> = ({ color, size }) => <IconWrapper {...{ size, color, renderIcon }} />
